import React from "react";
import { DataPickerStyle } from "./DataPickerStyle";
import DtPicker from "react-calendar-datetime-picker";
import { Label } from "../InputField/inputFieldStyle";
import "react-calendar-datetime-picker/dist/index.css";

export const DataPicker = ({
  label,
  onChange,
  className,
  value,
  placeholder,
  local,
}) => {
  let newtoday = new Date().toLocaleDateString("fa-IR");
  const formatDate = newtoday.split("/");
  const year = formatDate[0];
  const month = formatDate[1];
  const day = formatDate[2];
  return (
    <DataPickerStyle>
      {label ? <Label>{label}</Label> : null}
      <DtPicker
        onChange={onChange}
        local={local ? local : "fa"}
        className={className}
        initValue={value}
        placeholder={
          placeholder?.length > 1
            ? `${placeholder[0]}/${placeholder[1]}/${placeholder[2]}`
            : `${year}/${month}/${day}`
        }
        clearBtn
        clearBtnClass="clearButton"
      />
    </DataPickerStyle>
  );
};
